module.exports = __webpack_public_path__ + "static/media/centerIconPT.1ed24359.png";